import type * as React from 'react';
import { postFormData } from '@Domain/Api';
import documentTemplateCreated, {
	type DocumentTemplateCreatedAction,
	type DocumentTemplateCreatedPayload,
} from '@Application/Documents/Templates/Actions/documentTemplateCreated';
import documentTemplateCreationFailed, {
	type DocumentTemplateCreationFailedAction,
} from '@Application/Documents/Templates/Actions/documentTemplateCreationFailed';
import type CreateDocumentTemplate from '@Application/Documents/Templates/Commands/CreateDocumentTemplate';
import documentTemplateSectionDependenciesWarned, {
	type DocumentTemplateSectionDependenciesWarnedAction,
} from '@Application/Documents/Templates/Actions/documentTemplateSectionDependenciesWarned';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions =
	| DocumentTemplateCreatedAction
	| DocumentTemplateCreationFailedAction
	| DocumentTemplateSectionDependenciesWarnedAction;

export default (command: CreateDocumentTemplate) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await postFormData<DocumentTemplateCreatedPayload>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/document-templates`,
				command.toFormData(),
			);

			const action = documentTemplateCreated(payload);
			dispatch(action);

			const warningCount = payload.sectionDependencyWarnings.length;
			if (warningCount > 0) {
				dispatch(
					documentTemplateSectionDependenciesWarned({
						message: `${warningCount} dépendance(s) entre sections ne s'appliquent pas à ce gabarit.`,
					}),
				);
			}

			return action;
		} catch (error) {
			const action = documentTemplateCreationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
